import { z } from 'zod';

export const mapSchema = z.object({
  idObject: z.number().int().nonnegative(),
  name: z.string(),
  description: z.string().nullable().optional(),
  width: z.number().positive(),
  height: z.number().positive(),
  defaultCenterX: z.number().nullable().optional(),
  defaultCenterY: z.number().nullable().optional(),
  defaultZoomLevel: z.number().nullable().optional(),
  tileSize: z.number().optional(),
  references: z.array(z.unknown()).optional(),
  authors: z.array(z.unknown()).optional(),
  creationDate: z.string().nullable().optional(),
  modificationDates: z.array(z.string()).optional(),
  minZoom: z.number(),
  maxZoom: z.number(),
});

export const updateMapDataSchema = z.object({
  name: z.string().optional(),
  defaultCenterX: z.number().nullable().optional(),
  defaultCenterY: z.number().nullable().optional(),
  defaultZoomLevel: z.number().nullable().optional(),
});

export type Map = z.infer<typeof mapSchema>;
export type UpdateMapData = z.infer<typeof updateMapDataSchema>;
